module.exports = __webpack_public_path__ + "static/media/swxAutomateIcon.f044e82b.svg";